import React, { useState, useCallback } from 'react';
import { FilledGeneralThumbsup, OutlinedGeneralThumbsup, OutlinedGeneralThumbdown, FilledGeneralThumbdown } from '@hose/eui-icons';
import { sendAIFeedbackLike, sendAIFeedbackDislike } from '../../utils/postmate';
import './index.less';

export interface FeedbackData {
  chat_id?: string;
  content?: string; // AI摘要内容
  ai_chat?: string; // AI对话内容
  file_id?: string | string[];
  file_name?: string | string[];
}

export interface FeedbackButtonsProps {
  /** 反馈数据 */
  feedbackData: FeedbackData;
  /** 自定义样式类名 */
  className?: string;
}

/**
 * 反馈按钮组件 - 简化版本，组件内维护互斥状态
 */
export const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
  feedbackData,
  className = ''
}) => {
  const [likeActive, setLikeActive] = useState(false);
  const [dislikeActive, setDislikeActive] = useState(false);

  const handleLike = useCallback(() => {
    const newActiveState = !likeActive;
    setLikeActive(newActiveState);

    if (newActiveState) {
      setDislikeActive(false); // 互斥：激活点赞时取消点踩
      sendAIFeedbackLike({ ...feedbackData, action: 'like', feedback: '' });
    }
  }, [feedbackData, likeActive]);

  const handleDislike = useCallback(() => {
    const newActiveState = !dislikeActive;
    setDislikeActive(newActiveState);

    if (newActiveState) {
      setLikeActive(false); // 互斥：激活点踩时取消点赞
      sendAIFeedbackDislike({ ...feedbackData, action: 'dislike' });
    }
  }, [feedbackData, dislikeActive]);

  return (
    <div className={`feedback-buttons ${className}`}>
      {/* 点赞按钮 */}
      <div
        className='feedback-button'
        onClick={handleLike}
      >
        {likeActive ? <FilledGeneralThumbsup /> : <OutlinedGeneralThumbsup />}
        <span className="feedback-button__text">赞</span>
      </div>

      {/* 点踩按钮 */}
      <div
        className='feedback-button'
        onClick={handleDislike}
      >
        {dislikeActive ? <FilledGeneralThumbdown /> : <OutlinedGeneralThumbdown />}
        <span className="feedback-button__text">踩</span>
      </div>
    </div>
  );
};

export default FeedbackButtons;
